<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <router-link class="inverse" :to="{ name: 'users'}">
                    <span class="inverse__icon">
                        <span class="bar"></span>
                        <span class="bar"></span>
                    </span>
                    <span class="inverse__label">
                        {{ $t('common.back') }}
                    </span>
                </router-link>
            </div>
            <div class="card">
                <div class="card__detail">
                    <span v-if="loading">
                        {{ $t('common.loading') }}
                    </span>
                    <form class="form" @submit.prevent="submitForm">
                        <div class="form__field">
                            <label class="form__field-label">{{$t('users.name')}}</label>
                            <input class="form__field-input" v-model.trim="$v.form.name.$model"/>
                            <div class="field__validator_error" v-if="submitted && !$v.form.name.required">
                                {{ $t('users.errors.name_required') }}
                            </div>
                        </div>
                        <div class="form__field">
                            <label class="form__field-label">E-mail</label>
                            <input class="form__field-input" v-model.trim="$v.form.email.$model"/>
                            <div class="field__validator_error" v-if="submitted && !$v.form.email.required">
                                {{ $t('users.errors.email_required') }}
                            </div>
                            <div class="field__validator_error" v-if="submitted && !$v.form.email.email">
                                {{ $t('users.errors.email_not_formatted') }}
                            </div>
                        </div>
                        <div class="form__field">
                            <label class="form__field-label">Password</label>
                            <input class="form__field-input" type="password" v-model.trim="$v.form.password.$model"/>
                            <div class="field__validator_error" v-if="submitted && !$v.form.password.required">
                                {{ $t('users.errors.password_required') }}
                            </div>
                        </div>
                        <div class="form__field">
                            <label class="form__field-label">{{$t('users.retypepassword')}}</label>
                            <input class="form__field-input" type="password" v-model.trim="$v.form.retype_password.$model"/>
                            <div class="field__validator_error" v-if="submitted && !$v.form.retype_password.sameAsPassword">
                                {{ $t('users.errors.retype_password_not_equal_to_password') }}
                            </div>
                        </div>
                        <div class="form__field">
                            <label class="form__field-label">{{$t('users.role')}}</label>
                            <select class="form__field-select" type="password" v-model.trim="$v.form.role.$model">
                                <option value="USER">{{$t('users.roles.user')}}</option>
                                <option value="ADMIN">{{$t('users.roles.admin')}}</option>
                            </select>
                        </div>
                        <div class="form__field">
                            <button type="submit" class="btn form__field-btn" :disabled="loading">
                                <span v-if="loading">{{ $t('common.loading') }}</span> <span v-if="!loading">
                                    <span v-if="$route.params.id == 'new'">{{ $t('common.add') }}</span>
                                    <span v-if="$route.params.id != 'new'">{{ $t('common.save') }}</span>
                                </span>
                            </button>
                            <button type="button" @click="modalDeleteOpen = true" class="btn form__field-btn" :disabled="loading">
                                <span v-if="loading">{{ $t('common.loading') }}</span>
                                <span v-if="!loading">
                                    {{ $t('common.delete') }}
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <alert-modal v-model="showError" v-bind:title="$t('users.alert.error.generic.title')" v-bind:text="$t('users.alert.error.generic.text')"></alert-modal>
        <confirm-modal v-model="modalDeleteOpen" v-bind:title="$t('users.alert.delete.title')" v-bind:text="$t('users.alert.delete.text')" @result="confirmDelete($event)"></confirm-modal>
    </main>
</template>
<script>
    import {required, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
    import AlertModal from "../../components/AlertModal"
    import ConfirmModal from "../../components/ConfirmModal"

    export default {
        name: 'user_form',
        components: {AlertModal,ConfirmModal},
        mounted() {
            this.init();
        },
        data() {
            return {
                user: null,
                showError: false,
                submitted: false,
                error: '',
                loading: false,
                modalDeleteOpen: false,
                form: {
                    name: '',
                    email: '',
                    password: '',
                    retype_password: '',
                    role: 'USER'
                }
            }
        },
        // gestione della validazione
        validations: {
            form: {
                name: {
                    required
                },
                email: {
                    required,
                    email
                },
                password: {
                    // la password è richiesta se sto inserendo un nuovo utente
                    required: requiredIf(function () {
                        return this.$route.params.id == 'new';
                    })
                },
                retype_password: {
                    sameAsPassword: sameAs('password')
                },
                role: {
                    required
                }
            }
        },
        methods: {
            // inizializzo il tutto
            init() {
                // se id è new allora prendo i dati dell'utente
                // in caso di errore l'utente non ha i permessi
                // torno indietro
                if (this.$route.params.id !== 'new') {
                    this.loading = true;
                    this.api.users.getSingle(this.$route.params.id)
                        .then((u) => {
                            // assegno nella form i dati dell'utentes
                            Object.assign(this.form, u);
                            this.loading = false;
                        })
                        .catch(() => {
                            // in caso di errore, visualizzo l'errore
                            // e torno indietro
                            this.showError = true;
                            this.$watch('showError', () => {
                                if (!this.showError) {
                                    this.$router.back();
                                }
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            submitForm() {
                this.$v.$touch();
                this.submitted = true;
                this.error = '';
                this.loading = true;
                // controllo la validità della form
                // ci sarà un controllo anche lato server
                if (!this.$v.$invalid) {
                    this.loading = true;
                    this.api.users.save(this.form, this.$route.params.id)
                        .then(() => {
                            this.toast.success();
                            this.$router.push({ path: '/users' });
                        })
                        .catch((e) => {
                            this.toast.error(this.$t(`users.errors.${e.error}`));
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                } else {
                    this.loading = false;
                }
            },
            confirmDelete(e) {
                if(e) {
                    this.loading = true;
                    this.modalDeleteOpen = false;
                    this.api.users.delete(this.$route.params.id)
                        .then(() => {
                            this.toast.success();
                            this.$router.push({ path: '/users' });
                        })
                        .catch((e) => {
                            this.toast.error(this.$t(`users.errors.${e.error}`));
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    @import './src/scss/form';
    .card {
        &__header {
            display: flex;
            justify-content: space-between;
            background: transparent;
            height: auto;
            padding: 30px 0;
            .action {
                &__name {
                    font-weight: 300;
                    font-size: 1.3em;
                    color: $dark-green;
                }
                &__add {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    background: $middle-green;
                    padding: 10px 20px;
                    transition: 300ms $ease-out-quint;
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }
                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;
                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%,-50%);
                            &:last-of-type {
                                transform: translate(-50%,-50%) rotate(90deg);
                            }
                        }
                    }
                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                    &:hover {
                        background: $white;
                        .action__add {
                            &-icon .bar { background: $middle-green; }
                            &-label { color: $middle-green; }
                        }
                    }
                }
            }
            .card__header-link {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: $middle-green;
                padding: 10px 20px;
                transition: 300ms $ease-out-quint;
                .btn {
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }
                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;
                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%,-50%);
                            &:last-of-type {
                                transform: translate(-50%,-50%) rotate(90deg);
                            }
                        }
                    }
                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                }
                &:hover {
                    background: $white;
                    .btn {
                        &-icon .bar { background: $middle-green; }
                        &-label { color: $middle-green; }
                    }
                }
            }
        }
    }

</style>
